import { MS_IN_SEC } from './const';

const DIGIT_OF_NUMBER_IN_MIN = 10;

/**
 * Приводит timestamp к стандартным миллисекундам.
 *
 * @example
 * normalizeTimestamp(1699958377) → 1699958377000
 */
export const normalizeTimestamp = (input: number) => {
  const isMilliseconds = input.toString().length > DIGIT_OF_NUMBER_IN_MIN;

  if (isMilliseconds) {
    return input;
  }

  const output = input * MS_IN_SEC;

  return output;
};
